import { History, ExternalLink } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

const fmtDate = (s) => (s ? new Date(s).toLocaleString(undefined, { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" }) : "");

export function DocHistoryDialog({ doc, onClose, onOpen }) {
  const rows = doc?.history || [];
  return (
    <Dialog open={!!doc} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent className="max-w-xl" data-testid="doc-history-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><History className="w-4 h-4 text-[#003E87]" /> Earlier versions ({rows.length})</DialogTitle>
          <DialogDescription>The row in the folder is always the latest: {doc?.name}. Older versions are kept here, newest first.</DialogDescription>
        </DialogHeader>
        <div className="divide-y divide-slate-100 border border-slate-200 rounded-lg max-h-[55vh] overflow-y-auto" data-testid="doc-history-list">
          {rows.map((h) => (
            <div key={h.document_id} className="flex items-center gap-3 px-3 py-2" data-testid={`doc-history-row-${h.document_id}`}>
              <div className="min-w-0 flex-1">
                <div className="text-sm text-slate-800 truncate" title={h.name}>{h.name}</div>
                <div className="text-[11px] text-slate-400 flex gap-2">
                  <span>{fmtDate(h.created_at)}</span>
                  {h.version ? <span>v{h.version}</span> : null}
                  {h.archived ? <span className="px-1 rounded bg-slate-100 text-slate-500">archived</span> : null}
                </div>
              </div>
              <Button size="sm" variant="outline" className="h-7 text-xs shrink-0" onClick={() => onOpen(h)} data-testid={`doc-history-open-${h.document_id}`}>
                <ExternalLink className="w-3.5 h-3.5 mr-1" /> Open
              </Button>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
